import { render } from "./directLogin.vue?vue&type=template&id=645121de&scoped=true&ts=true"
import script from "./directLogin.vue?vue&type=script&lang=ts"
export * from "./directLogin.vue?vue&type=script&lang=ts"

import "./directLogin.vue?vue&type=style&index=0&id=645121de&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645121de"]])

export default __exports__